import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Outlet, useLocation } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";
import { MessageCircle } from "lucide-react";
import ThemeInjector from "@/components/ThemeInjector";

export default function PublicLayout() {
  const { settings } = useSettings();
  const loc = useLocation();

  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [loc.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-[color:var(--marupiara-ivory)]">
      <ThemeInjector />
      <Navbar />
      <main className="flex-1 pt-20">
        <Outlet />
      </main>
      <Footer />
      {settings.whatsapp && (
        <a
          href={`https://wa.me/${settings.whatsapp}`}
          target="_blank"
          rel="noreferrer"
          data-testid="floating-whatsapp"
          aria-label="WhatsApp"
          className="fixed bottom-6 right-6 z-40 h-14 w-14 flex items-center justify-center rounded-full text-white shadow-xl transition-transform hover:scale-110"
          style={{ background: "#25D366" }}
        >
          <MessageCircle size={26} />
        </a>
      )}
    </div>
  );
}
